import { PropsWithChildren } from 'react';
import { useAppBarHeight } from '../useAppBarHeight';

type GridWrapperWithAppBarHeightProps = PropsWithChildren<{
  sideBarWidth?: `${number}px`;
}>;

/**
 GridWrapperWithAppBarHeight component is used to wrap the content of the page with the appbar height.
 * @param props.sideBarWidth - width of the sidebar in pixels default: 420px
 */
export function GridWrapperWithAppBarHeight({ children, sideBarWidth = '420px' }: GridWrapperWithAppBarHeightProps) {
  const { heightWithoutAppBar } = useAppBarHeight();

  return (
    <div
      className="grid border-r border-border-divider [&>div:nth-of-type(odd)]:border-r [&>div:nth-of-type(odd)]:border-border-divider"
      style={{ gridTemplateColumns: `calc(100% - ${sideBarWidth}) ${sideBarWidth}`, height: heightWithoutAppBar }}
    >
      {children}
    </div>
  );
}
